import { all, call, fork, put, select, takeEvery, take, ForkEffect, AllEffect, getContext } from 'redux-saga/effects';
import { AuthActionTypes } from './types';
import * as actions from './actions';
import { logout } from './actions';
import * as OfferActions from '../offers/actions';
import LogRocket from 'logrocket';
import { CHANNEL, TOPIC } from 'types';
import { sagaMiddleware } from '../configureStore';
import { getStudent, getAuth } from '../selectors';
import { StudentState } from '../student/types';
import * as studentActions from '../student/actions';
import { getMainSaga, websocketActions } from 'websocket-utility';
import { getWSSUrl } from '../../utilities/envVariables';
import { UIActionTypes } from '../ui/types';

function* handleLogout() {
  // console.log('logout called!');
  const auth = yield select(getAuth);
  if (auth.isLoggedIn) {
    // console.log('logout called! 2');
    yield put(actions.logoutSuccess());
  }
}

function* getActiveOffers() {
  yield put(OfferActions.getActiveOffers());
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired');
      return;
    }
    const userName: string = context.username;

    yield LogRocket.identify(userName, {
      email: context.email,
      uni: context.uni
    });

    if (window && (window as any).Appcues) {
      yield (window as any).Appcues.identify(userName, {
        email: context.email,
        uni: context.uni,
        role: 'Student'
      });
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
}

function* handleRegisterInitialWebsockets(): any {
  let student: StudentState = yield select(getStudent);
  if (!student?.core?.student_id) {
    yield take('@@student/GET_STUDENT_RECORD_SUCCESS');
  }
  student = yield select(getStudent);

  const studentSubKey = {
    channel: CHANNEL.STUDENT,
    view: `${student.core.university}#${student.summary.intakeId}`,
    topic: [
      TOPIC.CALENDLY_INTERVIEWS,
      TOPIC.CALENDLY_INTERVIEW_DOCS,
      TOPIC.DOCUMENTS,
      TOPIC.FINANACE_DOCUMENTS,
      TOPIC.FOLLOW_UP_DOCUMENTS,
      TOPIC.MESSAGES,
      TOPIC.RECORDED_INTERVIEWS,
      TOPIC.RECORDED_INTERVIEW_DOCS,
      TOPIC.STUDENT_CORE,
      TOPIC.STUDENT_DETAILS,
      TOPIC.STUDENT_FINANCE
    ],
    subject: student.core.student_number
  };
  yield put(
    websocketActions.subscribeToWebsocket({
      key: JSON.stringify(studentSubKey),
      handler: studentActions.handleWebsocketStudentRecords
    })
  );
}

function* watchLogoutRequest() {
  yield takeEvery(AuthActionTypes.LOGOUT_REQUEST, handleLogout);
}

function* handleRegisterWebsocketSaga() {
  const context = yield getContext('sagaContext');
  const idToken: any = yield call(context.getIdToken);
  if (!idToken) {
    yield put(logout());
    yield call(context.onLogout);
    console.log('Refresh Token has Expired');
    return;
  }
  const wssUrl: string = yield call(getWSSUrl);
  // const authData = awsApi.getAuthData();
  const auth = yield select(getAuth);
  if (auth.isLoggedIn) {
    // calling HOC to async inject into middleware
    const websocketSaga = getMainSaga(wssUrl, idToken!);
    sagaMiddleware.run(websocketSaga);
  }
}

function* watchAuthSuccess() {
  yield takeEvery(UIActionTypes.SET_CONTEXT_SUCCESS, getActiveOffers);
  yield takeEvery(UIActionTypes.SET_CONTEXT_SUCCESS, handleRegisterWebsocketSaga);
}

function* watchWSConnect() {
  yield takeEvery('CONNECTION_SUCCESS', handleRegisterInitialWebsockets);
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* AuthSaga(): Generator<ForkEffect<never> | AllEffect<ForkEffect<void>>, void, unknown> {
  yield all([fork(watchLogoutRequest)]);
  yield all([fork(watchAuthSuccess)]);
  yield all([fork(watchWSConnect)]);
}

export default AuthSaga;
